<template>
  <div class="modal-unopen-box" v-if="showModal">
    <!-- <uni-popup ref="dialog" type="center" @change="change"> -->
    <div class="box-prize" animation="">
      <div class="open-prize text-no-select" style="">
        <!---->
        <div class="single-prize-th1">
          <div class="abs-full bk-line-gi"></div>
          <div class="bk-layer">
            <div class="bk-top"></div>
            <div class="bk-extend"></div>
            <div class="bk-mid"></div>
            <div class="bk-extend bk-extend1"></div>
            <div class="bk-btm"></div>
          </div>
          <div class="bk-layer1">
            <div class="bk-top"></div>
            <div class="bk-extend"></div>
            <div class="bk-mid"></div>
            <div class="bk-extend bk-extend1"></div>
            <div class="bk-btm"></div>
          </div>
          <!-- 单开 -->
          <div class="th1-outer-box" v-if="num == 1">
            <div class="sp01-box">
              <div class="outer-box">
                <div class="inner-box">
                  <div class="anim-box" :style="{
                    transform: `translate3d(0px, ${dynamic}px, 0px)`,
                  }" style="
                      transition-timing-function: ease-in-out;
                      transition-duration: 6s;
                    ">
                    <div class="item-box" v-for="(item, index) in products" :key="index">
                      <div class="item-color" :class="getColor(item.ornamentsLevelId)">
                        <!-- 开箱图片 -->

                        <img :src="item.imageUrl" alt="" class="item-prod" mode="widthFix" />
                        <!-- 开箱图片 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="abs-full prize-divider"></div>
          </div>
          <!-- 多开 -->
          <div class="th1-outer-box" v-else>
            <div class="sp01-box">
              <div class="outer-box">
                <div class="inner-box inner-boxs" :class="`inner-box-${num}`">
                  <div class="anim-box anim-boxs" v-for="item1 in num" :key="item1" :style="{
                    transform: `translate3d(0px, ${dynamic}px, 0px)`,
                    'transition-duration': `${getRandomSecond()}s`,
                  }" style="transition-timing-function: ease-in-out">
                    <div class="item-box item-boxs" v-for="(item, index) in products[item1 - 1]" :key="index"
                      :data="item.prop">
                      <div class="item-color boxs" :class="getColor(item.ornamentsLevelId)">
                        <img :src="item.imageUrl" class="item-prod" mode="widthFix" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="abs-full prize-divider"></div>
          </div>
        </div>
        <!---->
      </div>
    </div>
    <!-- </uni-popup> -->
  </div>
</template>
<script>
import { getDetail, openBox } from "@/api/index";
export default {
  data() {
    return {
      products: [],
      bg: ["bk-golden", "bk-red", "bk-purple", "bk-blue"],
      dynamic: 0,
      player_skins_ids: "",
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    boxDetail: {
      type: Array,
      default: [],
    },
    num: {
      type: Number,
    },
    boxId: {
      type: Number,
      default: "",
    },
    openBoxData: {
      type: Array,
      default: [],
    },
  },
  watch: {
    showModal(newValue, oldValue) {
      if (newValue) {
        this.getOpenProducts();
        // this.$refs.dialog.open();
      } else {
        this.dynamic = 0;
      }
    },
  },
  mounted() {
    // this.getOpenProducts(285)
    // this.$nextTick(() => {
    // 	this.$refs.dialog.open()
    // })
  },
  methods: {
    getColor(color) {
      if (color == "1") {
        return "bk-golden";
      }
      if (color == "2") {
        return "bk-red";
      }
      if (color == "3") {
        return "bk-purple";
      }
      if (color == "4") {
        return "bk-blue";
      }
    },
    close() {
      this.$emit("close");
    },
    // change(e) {
    //   if (!e.show) {
    //     this.soundPlay("dialogClose");
    //   } else {
    //   }
    //   this.$emit("change", e.show);
    // },
    // 打乱数组
    getRandomArr(arr, num) {
      var _arr = arr.concat();
      var n = _arr.length;
      var result = [];

      // 先打乱数组
      while (n-- && num--) {
        var index = Math.floor(Math.random() * n); // 随机位置
        [_arr[index], _arr[n]] = [_arr[n], _arr[index]]; // 交换数据
        result.push(_arr[n]); // 取出当前最后的值，即刚才交换过来的值
      }
      return result;
    },
    async getOpenProducts() {
      const that = this;
      let boxInfoList = [];
      let skinsInfo = [];
      let imgCopy = this.boxDetail;
      let imgCopy1 = [];
      for (let i = 0; i < Math.floor(80 / imgCopy.length) + 1; i++) {
        for (let j = 0; j < imgCopy.length; j++) {
          imgCopy1.push(imgCopy[j]);
        }
      }
      // 判断是单开还是多开
      if (that.num == 1) {
        imgCopy1 = imgCopy1.slice(0, 80);
        imgCopy1 = that.getRandomArr(imgCopy1, 80);
        boxInfoList = imgCopy1;
      } else {
        for (let i = 0; i < that.num; i++) {
          imgCopy1 = imgCopy1.slice(0, 80);
          imgCopy1 = that.getRandomArr(imgCopy1, 80);
          boxInfoList.push(imgCopy1);
        }
      }

      // 替换中奖位置
      const openBoxData = this.openBoxData;
      // debugger
      if (that.num == 1) {
        boxInfoList[44] = { ...openBoxData[0], prop: 1 };
        skinsInfo[0] = { ...openBoxData[0] };
      } else {
        for (let i = 0; i < that.num; i++) {
          boxInfoList[i][44] = { ...openBoxData[i], prop: 1 };
          skinsInfo[i] = { ...openBoxData[i] };
        }
      }
      that.products = boxInfoList;
      setTimeout(() => {
        that.$nextTick((e) => {
          const num = that.num;
          switch (num) {
            case 1:
            case 2:
              that.dynamic = -3594;
              break;
            case 3:
              that.dynamic = -3095;
              break;
            case 4:
              that.dynamic = -2393;
              break;
            case 5:
              that.dynamic = -1805;
              break;
          }
          this.$forceUpdate();
          this.$soundPlay("dialogOpen");
          this.$soundPlay("boxAnimS");
          console.log(skinsInfo, "开箱结果");
          setTimeout(() => {
            this.products = [];
            this.$emit("openResult", skinsInfo);
            this.close();
          }, 8000);
        });
      }, 100);

      // });
      // that.$utils
      //   .requestPost(
      //     "/api/box/buyboxfake",
      //     { box_id: box_id, num: that.num },
      //     "加载中"
      //   )
      //   .then((res) => {
      //     if (!res.errMsg) {

      //     }
      //   });
    },
    // 随机返回4-6秒之间
    getRandomSecond() {
      return (Math.random() * (6 - 5) + 5).toFixed(1);
    },
  },
};
</script>

<style scoped lang="scss">
.bk-golden {
  background-image: url("../../assets/images/bk_golden1.png");
}

.bk-blue {
  background-image: url("../../assets/images/bk_blue1.png");
}

.bk-purple {
  background-image: url("../../assets/images/bk_purple1.png");
}

.bk-red {
  background-image: url("../../assets/images/bk_red1.png");
}

.open-prize {
  position: absolute;
  z-index: 101;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.85);
}

.text-no-select {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: auto;
  /* Chrome/Safari/Opera */
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently not supported by any browser */
}

.prize-inner {
  width: 197.33 * 4.2px;
  height: 90.67 * 4.2px;
}

.single-prize-th1 {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-animation: bkgAnimKf-data-v-1a47b96c 0.3s linear 0s 1;
  animation: bkgAnimKf-data-v-1a47b96c 0.3s linear 0s 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0;
}

.single-prize-th1 .bk-line-gi {
  z-index: -1;
  opacity: 0.5;
  background-size: 44 * 4.2px 100%;
  background-repeat: no-repeat;
  background-position: left 29.33 * 4.2px center;
  background-image: url("../../assets/images/box_bk_line.gif");
}

.single-prize-th1 .bk-layer {
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.single-prize-th1 .bk-layer .bk-top {
  height: 46.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_anim_bk1.png");
}

.single-prize-th1 .bk-layer .bk-extend {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.single-prize-th1 .bk-layer .bk-mid {
  height: 36.93 * 4.2px;
  background-repeat: no-repeat;
  background-position: center top 1px;
  background-size: 63.73 * 4.2px 100%;
  background-image: url("../../assets/images/box_anim_bk4.png");
  position: relative;
}

.single-prize-th1 .bk-layer .bk-btm {
  height: 46.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_anim_bk3.png");
}

.single-prize-th1 .bk-layer1 {
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.single-prize-th1 .bk-layer1 .bk-top {
  height: 22.8 * 4.2px;
}

.single-prize-th1 .bk-layer1 .bk-extend {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 46.13 * 4.2px 100%;
  background-image: url("../../assets/images/box_anim_bk2.png");
}

.single-prize-th1 .bk-layer1 .bk-extend1 {
  background-image: url("../../assets/images/box_anim_bk21.png");
}

.single-prize-th1 .bk-layer1 .bk-mid {
  height: 28.13 * 4.2px;
}

.single-prize-th1 .bk-layer1 .bk-btm {
  height: 22.8 * 4.2px;
}

@-webkit-keyframes bkgAnimKf-data-v-1a47b96c {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleY(0.1);
    transform: scaleY(0.1);
  }

  100% {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}

@keyframes bkgAnimKf-data-v-1a47b96c {
  0% {
    opacity: 0.1;
    -webkit-transform: scaleY(0.1);
    transform: scaleY(0.1);
  }

  100% {
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}

.single-prize-th1 .th1-outer-box {
  z-index: 2;
  position: relative;
  width: 100%;
  height: 100%;
}

.single-prize-th1 .th1-outer-box .box-mask {
  width: 9.87 * 4.2px;
  height: 20.4 * 4.2px;
  position: absolute;
  top: 0.47 * 4.2px;
  z-index: 3;
}

.single-prize-th1 .th1-outer-box .left-mask {
  left: 0;
}

.single-prize-th1 .th1-outer-box .right-mask {
  right: 0;
}

.single-prize-th1 .th1-outer-box .prize-divider {
  z-index: 3;
  background-size: 100% 52 * 4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/prize_divider.png");
}

.single-prize-th1 .bkg-img {
  position: absolute;
  background: transparent;
  width: 94.67 * 4.2px;
  height: 21.47 * 4.2px;
  left: -1.33 * 4.2px;
  top: 0;
  z-index: 5;
}

.single-prize-th1 .bkg-img .title-img1 {
  position: absolute;
  width: 72.4 * 4.2px;
  height: 16.53 * 4.2px;
  margin: -7.47 * 4.2px 0 0 57.33 * 4.2px;
}

.single-prize-th1 .sp01-box {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.single-prize-th1 .sp01-box .outer-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-block;
}

.single-prize-th1 .sp01-box .inner-box {
  position: absolute;
  top: -webkit-calc(50% - 194.4 * 4.2px/2);
  top: calc(50% - 194.4 * 4.2px / 2);
  left: 35.33 * 4.2px;
  height: 194.4 * 4.2px;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-animation: prizeAnimKf-data-v-1a47b96c 0.2s linear 0.2s 1;
  animation: prizeAnimKf-data-v-1a47b96c 0.2s linear 0.2s 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0;
}

@-webkit-keyframes prizeAnimKf-data-v-1a47b96c {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes prizeAnimKf-data-v-1a47b96c {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.single-prize-th1 .sp01-box .anim-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  // width: 28.8*4.2px;
}

.single-prize-th1 .sp01-box .anim-box .item-box {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 28.8 * 4.2px;
  height: 90px;
}

.single-prize-th1 .sp01-box .anim-box .item-box .item-color {
  position: relative;
  height: 100%;
  width: 100%;
  margin-left: 0;
  background-size: 100% 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.single-prize-th1 .sp01-box .anim-box .item-box .item-color .item-prize {
  position: absolute;
  top: 0;
  left: -2.4 * 4.2px;
  width: 33.87 * 4.2px;
  height: 21.6 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_border.png");
}

.single-prize-th1 .sp01-box .anim-box .item-box .item-color .item-prod {
  position: absolute;
  height: auto;
  width: 90%;
}

.single-prize-th1 .sp01-box .anim-box .item-box .item-color .gold-mask {
  position: absolute;
  width: 100%;
  height: 100%;
}

// 多开样式
.inner-boxs {
  width: 100%;
  left: 50% !important;
  transform: translateX(-50%);
  display: flex;
  align-content: center;
  flex-direction: column;
  flex-wrap: wrap;

  .anim-boxs {
    margin: 0 1 * 4.2px;
  }
}

.inner-box-3 {
  .anim-boxs {
    width: 25 * 4.2px !important;
    float: left;
  }

  .item-boxs {
    width: 25 * 4.2px !important;
    height: 18.75 * 4.2px !important;
  }
}

.inner-box-4 {
  .anim-boxs {
    width: 20 * 4.2px !important;
    float: left;
  }

  .item-boxs {
    width: 20 * 4.2px !important;
    height: 15 * 4.2px !important;
  }
}

.inner-box-5 {
  .anim-boxs {
    width: 15.8 * 4.2px !important;
    float: left;
  }

  .item-boxs {
    width: 15.8 * 4.2px !important;
    height: 11.85 * 4.2px !important;
  }
}

@media only screen and (max-width: 430px) {
  // .prize-inner {
  //   width: 197.33vw;
  //   height: 90.67vw;
  // }

  // .single-prize-th1 .bk-line-gi {
  //   background-size: 44vw 100%;

  //   background-position: left 29.33vw center;
  // }

  // .single-prize-th1 .bk-layer .bk-top {
  //   height: 46.4vw;
  // }

  // .single-prize-th1 .bk-layer .bk-mid {
  //   height: 36.93vw;

  //   background-size: 63.73vw 100%;
  // }

  // .single-prize-th1 .bk-layer .bk-btm {
  //   height: 46.4vw;
  // }

  // .single-prize-th1 .bk-layer1 .bk-top {
  //   height: 22.8vw;
  // }

  // .single-prize-th1 .bk-layer1 .bk-extend {
  //   background-size: 46.13vw 100%;
  // }

  // .single-prize-th1 .bk-layer1 .bk-mid {
  //   height: 28.13vw;
  // }

  // .single-prize-th1 .bk-layer1 .bk-btm {
  //   height: 22.8vw;
  // }

  // .single-prize-th1 .th1-outer-box .box-mask {
  //   width: 9.87vw;
  //   height: 20.4vw;

  //   top: 0.47vw;
  // }

  // .single-prize-th1 .th1-outer-box .prize-divider {
  //   background-size: 100% 52vw;
  // }

  // .single-prize-th1 .bkg-img {
  //   width: 94.67vw;
  //   height: 21.47vw;
  //   left: -1.33vw;
  // }

  // .single-prize-th1 .bkg-img .title-img1 {
  //   width: 72.4vw;
  //   height: 16.53vw;
  //   margin: -7.47vw 0 0 57.33vw;
  // }

  .single-prize-th1 .sp01-box .inner-box {
    left: 35.33vw;
  }

  .single-prize-th1 .sp01-box .anim-box .item-box {
    width: 28.8vw;
  }

  // .single-prize-th1 .sp01-box .anim-box .item-box .item-color .item-prize {
  //   left: -2.4vw;
  //   width: 33.87vw;
  //   height: 21.6vw;
  // }

  // // 多开样式
  // .inner-boxs {
  //   .anim-boxs {
  //     margin: 0 1vw;
  //   }
  // }
  // .inner-box-3 {
  //   .anim-boxs {
  //     width: 25vw !important;
  //     float: left;
  //   }
  //   .item-boxs {
  //     width: 25vw !important;
  //     height: 18.75vw !important;
  //   }
  // }
  // .inner-box-4 {
  //   .anim-boxs {
  //     width: 20vw !important;
  //   }
  //   .item-boxs {
  //     width: 20vw !important;
  //     height: 15vw !important;
  //   }
  // }
  // .inner-box-5 {
  //   .anim-boxs {
  //     width: 15.8vw !important;
  //   }
  //   .item-boxs {
  //     width: 15.8vw !important;
  //     height: 11.85vw !important;
  //   }
  // }
}
</style>